import React from "react";

import { Account } from "features/Account";
import { PageTitle } from "shared/ui";

const AccountPage = () => {
    return (
        <>
            <PageTitle>Аккаунт</PageTitle>
            <Account />
        </>
    );
};

export default AccountPage;
